import { render } from "./CompareErp.vue?vue&type=template&id=7c045f5c&scoped=true"
const script = {}

import "./CompareErp.vue?vue&type=style&index=0&id=7c045f5c&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c045f5c"]])

export default __exports__